import { render } from "./UserFilterChips.vue?vue&type=template&id=632e2376"
import script from "./UserFilterChips.vue?vue&type=script&lang=js"
export * from "./UserFilterChips.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__